import React, { forwardRef, Ref } from "react"
import { Icon, IconProps } from "@mezo-org/mezo-clay"

export type MezoSquareProps = {
  symbolColor?: string
} & IconProps

// TODO: Should be moved to the Clay library
function MezoSquare(props: MezoSquareProps, ref: Ref<SVGSVGElement>) {
  const {
    title,
    size = 16,
    color = "#000",
    symbolColor = "#FF004D",
    ...restProps
  } = props

  return (
    <Icon
      ref={ref}
      viewBox="0 0 16 16"
      title={title ?? "Mezo Square"}
      size={size}
      color={color}
      role="graphics-symbol"
      {...restProps}
    >
      <rect width="16" height="16" rx="4" fill={color} />
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill={color}
      />
      <path
        d="M4.53631 8.94103L5.76516 7.70996V7.70433L6.98769 8.93466C7.34111 9.28839 7.773 9.44628 8.19905 9.44628C9.09099 9.44628 9.94892 8.74984 9.94892 7.70433L11.1715 8.93466C11.5249 9.28839 11.9568 9.44628 12.3828 9.44628C13.2748 9.44628 14.1327 8.74984 14.1327 7.70433H13.0834L11.8608 6.47964C11.5074 6.12591 11.0702 5.96802 10.6439 5.96802C9.75193 5.96802 8.89958 6.65882 8.89958 7.70433L7.67705 6.47964C7.32362 6.12566 6.8864 5.96777 6.46035 5.96777C5.5684 5.96777 4.71606 6.65858 4.71606 7.70409L1.57458 7.70972C1.57458 8.76086 2.44369 9.44065 3.33564 9.44065C3.76193 9.44065 4.1943 9.28276 4.53606 8.94103H4.53679H4.53631Z"
        fill={symbolColor}
      />
    </Icon>
  )
}

export default forwardRef<SVGSVGElement, IconProps>(MezoSquare)
